// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".keyword-settings__results>ul,.keyword-settings__results>p{background:#f9fbfe;border:1px solid #ecf1f9;padding:1rem;font-size:1.1rem;font-weight:500}.keyword-settings__results>ul{list-style:none}.keyword-settings__results>ul>li{margin-bottom:0.5rem;color:#1E2B4E}\n", ""]);
// Exports
module.exports = exports;
